import React from 'react';

export default function ServicesGrid() {
  return (
    <section className="w-full bg-[#f8f9fa] py-6 font-sans text-gray-800 ">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ">
        
        {/* ================= BOTTOM 5 CARDS SECTION ================= */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          
          {/* Card 1 */}
          <div className="bg-white rounded-2xl p-5 shadow-[0_4px_20px_rgba(0,0,0,0.03)] border border-gray-100 flex flex-col justify-between hover:shadow-md transition-shadow">
            <div>
              <div className="w-9 h-9 rounded-xl bg-[#f25c05] flex items-center justify-center text-white mb-4 shadow-sm">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4" />
                </svg>
              </div>
              <h3 className="text-sm font-bold text-gray-900 mb-2 leading-tight">Software Development</h3>
              <p className="text-[11px] text-gray-500 leading-relaxed mb-6">
                Custom software solutions designed to meet your unique business needs.
              </p>
            </div>
            <a href="/services/software-development" className="inline-flex items-center space-x-1 text-[11px] font-bold text-[#f25c05] hover:underline">
              <span>Learn More</span>
              <span className="text-xs">→</span>
            </a>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-2xl p-5 shadow-[0_4px_20px_rgba(0,0,0,0.03)] border border-gray-100 flex flex-col justify-between hover:shadow-md transition-shadow">
            <div>
              <div className="w-9 h-9 rounded-xl bg-[#f25c05] flex items-center justify-center text-white mb-4 shadow-sm">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 15a4 4 0 004 4h9a5 5 0 001-9.999 5.002 5.002 0 00-9.78 2.096A4.001 4.001 0 003 15z" />
                </svg>
              </div>
              <h3 className="text-sm font-bold text-gray-900 mb-2 leading-tight">Cloud Solutions</h3>
              <p className="text-[11px] text-gray-500 leading-relaxed mb-6">
                Scalable and secure cloud services to accelerate your digital transformation.
              </p>
            </div>
            <a href="/services/cloud-solutions" className="inline-flex items-center space-x-1 text-[11px] font-bold text-[#f25c05] hover:underline">
              <span>Learn More</span>
              <span className="text-xs">→</span>
            </a>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-2xl p-5 shadow-[0_4px_20px_rgba(0,0,0,0.03)] border border-gray-100 flex flex-col justify-between hover:shadow-md transition-shadow">
            <div>
              <div className="w-9 h-9 rounded-xl bg-[#f25c05] flex items-center justify-center text-white mb-4 shadow-sm">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-sm font-bold text-gray-900 mb-2 leading-tight">Cyber Security</h3>
              <p className="text-[11px] text-gray-500 leading-relaxed mb-6">
                Protect your business with advanced security solutions and best practices.
              </p>
            </div>
            <a href="/services/cyber-security" className="inline-flex items-center space-x-1 text-[11px] font-bold text-[#f25c05] hover:underline">
              <span>Learn More</span>
              <span className="text-xs">→</span>
            </a>
          </div>

          {/* Card 4 */}
          <div className="bg-white rounded-2xl p-5 shadow-[0_4px_20px_rgba(0,0,0,0.03)] border border-gray-100 flex flex-col justify-between hover:shadow-md transition-shadow">
            <div>
              <div className="w-9 h-9 rounded-xl bg-[#f25c05] flex items-center justify-center text-white mb-4 shadow-sm">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                </svg>
              </div>
              <h3 className="text-sm font-bold text-gray-900 mb-2 leading-tight">IT Consulting</h3>
              <p className="text-[11px] text-gray-500 leading-relaxed mb-6">
                Expert guidance to optimize your IT strategy and drive business growth.
              </p>
            </div>
            <a href="/services/it-consulting" className="inline-flex items-center space-x-1 text-[11px] font-bold text-[#f25c05] hover:underline">
              <span>Learn More</span>
              <span className="text-xs">→</span>
            </a>
          </div>

          {/* Card 5 */}
          <div className="bg-white rounded-2xl p-5 shadow-[0_4px_20px_rgba(0,0,0,0.03)] border border-gray-100 flex flex-col justify-between hover:shadow-md transition-shadow">
            <div>
              <div className="w-9 h-9 rounded-xl bg-[#f25c05] flex items-center justify-center text-white mb-4 shadow-sm">
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 100-6 3 3 0 000 6z" />
                </svg>
              </div>
              <h3 className="text-sm font-bold text-gray-900 mb-2 leading-tight">Managed IT Services</h3>
              <p className="text-[11px] text-gray-500 leading-relaxed mb-6">
                End-to-end IT support and management to keep your business running smoothly.
              </p>
            </div>
            <a href="/services/managed-it-services" className="inline-flex items-center space-x-1 text-[11px] font-bold text-[#f25c05] hover:underline">
              <span>Learn More</span>
              <span className="text-xs">→</span>
            </a>
          </div>

        </div>

      </div>
    </section>
  );
}